
<template>
    <div class= 'container'>
      <div class = 'compass'>
          <div class = 'centerCompass' :style="centerCompassStyle"  >
            <div class = 'centerPointer'></div>
          </div>
          <!-- 中心指北针背景，用于点击事件 -->
          <div class = 'centerCompassBack'  @click="centerCompassClick" title="dasg">
          </div>
          <!-- 旋转按钮 -->
          <div class = 'pitchUp' :class="{'pitchStyleClass':pitchStatus === 'up'}"
          @mousedown="pitchMouseDown('up')"
          @mouseup="pitchMouseUp('up')"
          ></div>
          <div class = 'pitchDown' :class="{'pitchStyleClass':pitchStatus === 'down'}"
          @mousedown="pitchMouseDown('down')"
          @mouseup="pitchMouseUp('down')"
          ></div>
          <div class = 'rotateLeft'   @mousedown="rotateMouseDown('left')" @mouseup="pitchMouseUp('left')"></div>
          <div class = 'rotateRight'  @mousedown="rotateMouseDown('right')" @mouseup="pitchMouseUp('right')"></div>
      </div>
    </div>
</template>
<script>
 // eslint-disable
import {
  Math as CesiumMath, Cartesian2, Ellipsoid, Cartesian3, Quaternion, Matrix3, Matrix4 } from "cesium/Cesium";
  export default {
    name: "test",
    data() {
      return {
        centerCompassStyle: {
          transform: ""
        },
        pitchStatus: null, // 切斜角调整按钮的状态
        compassEvent: null
      };
    },
    props: {
      // 接收外部地图对象创建状态
      sceneBool: {
        type: Boolean,
        default: false
      }
    },
    // 外部地图对象初始化完成 初始化罗盘
    watch: {
      sceneBool (val) {
          if (val) {
            this.initCompass();
          }
        }
    },
    destroyed() {
      if (this.compassEvent) {
        this.compassEvent();
      }
    },
    mounted () {
    },
    methods: {
      initCompass() {
             this.compassEvent = window.viewer.scene.postRender.addEventListener((e) => {
                   let x = CesiumMath.toDegrees(window.viewer.scene.camera.pitch) + 90;
                   let z = -CesiumMath.toDegrees(window.viewer.scene.camera.heading);
                   let t = "rotateX(" + x + "deg) rotateZ(" + z + "deg)";
                   this.centerCompassStyle = {
                      transform: t
                   };
                });
      },
      // 计算A点,相对B点,绕normal方向轴旋转angle角度后的位置
      calPositionByAxisAngle(normal, A, B, angle) {
          let Q = Quaternion.fromAxisAngle(normal, CesiumMath.toRadians(angle));
          let m3 = Matrix3.fromQuaternion(Q);
          let m4 = Matrix4.fromRotationTranslation(m3);
          let A1 = new Cartesian3();
          Cartesian3.subtract(A, B, A1);
          let p = Matrix4.multiplyByPoint(m4, A1, new Cartesian3());
          let poistion = Cartesian3.add(p, B, new Cartesian3());
          return poistion;
      },
      // 计算相机位置，相对地面中心点,绕两点的平面法向量，旋转angle角度后的位置
      calCameraPosition(angle, centerPosition) {
          let x = window.viewer.canvas.clientWidth / 2;
          let y = window.viewer.canvas.clientHeight / 2;
          let cameraPosition = window.viewer.camera.positionWC;
          let screenDirectionPosition = null;
          let normal = new Cartesian3(); // 平面法向量
          if (parseInt(CesiumMath.toDegrees(window.viewer.camera.pitch)) === -90) {
             // 当相机位置与中心点位置向量重合时，计算中心点上方1/2处，计算方向
             screenDirectionPosition = window.viewer.camera.pickEllipsoid(new Cartesian2(x, y / 2)); // 获取中心点上方的位置，用于计算旋转方向
          } else {
             screenDirectionPosition = centerPosition;
          }
          Cartesian3.cross(screenDirectionPosition, cameraPosition, normal);// 计算旋转平面法向量
          Cartesian3.normalize(normal, normal);// 平面法向量的单位正交化
          let position = this.calPositionByAxisAngle(normal, cameraPosition, centerPosition, angle);
          return position;
      },
      pitchClick(type) {
          let angleDelta = 1;
          this.pitchStatus = "";
          let x = window.viewer.canvas.clientWidth / 2;
          let y = window.viewer.canvas.clientHeight / 2;
          let centerPosition = window.viewer.camera.pickEllipsoid(new Cartesian2(x, y)); // 获取中心点位置
          if (centerPosition) {
            if (type === "up") {
              if (parseInt(CesiumMath.toDegrees(window.viewer.camera.pitch)) >= -5) {
                this.pitchStatus = "up"; // 不能再继续改变倾斜角
                return;
            }
              window.viewer.camera.setView({
                destination: this.calCameraPosition(angleDelta, centerPosition, centerPosition),
                orientation: {
                    heading: window.viewer.camera.heading,
                    pitch: window.viewer.camera.pitch - CesiumMath.toRadians(-angleDelta),
                    roll: 0.0
                }
              });
          } else if (type === "down") {
              if (parseInt(CesiumMath.toDegrees(window.viewer.camera.pitch)) <= -88) {
                  this.pitchStatus = "down"; // 不能再继续改变倾斜角
                  return;
                }
              window.viewer.camera.setView({
                  destination: this.calCameraPosition(-angleDelta, centerPosition),
                  orientation: {
                      heading: window.viewer.camera.heading,
                      pitch: window.viewer.camera.pitch - CesiumMath.toRadians(angleDelta),
                      roll: 0.0
                  }
              });
           }
          }
      },
      pitchMouseDown(type) {
        this.intervalID = setInterval(() => {
            this.pitchClick(type);
        }, 30);
      },
      pitchMouseUp(type) {
        if (this.intervalID) {
           clearInterval(this.intervalID);
           this.intervalID = null;
        }
      },
      rotateMouseDown(type) {
        this.intervalID = setInterval(() => {
            this.rotateClick(type);
        }, 30);
      },
      rotateMouseUp(type) {
        if (this.intervalID) {
           clearInterval(this.intervalID);
           this.intervalID = null;
        }
      },
      rotateClick(type) {
           let x = window.viewer.canvas.clientWidth / 2;
          let y = window.viewer.canvas.clientHeight / 2;
          let result = window.viewer.camera.pickEllipsoid(new Cartesian2(x, y)); // 获取中心点位置
          if (result) {
            if (type === "left") {
              window.viewer.camera.rotate(result, CesiumMath.toRadians(1));// 绕中心点向量旋转
            } else if (type === "right") {
              window.viewer.camera.rotate(result, CesiumMath.toRadians(-1));
            }
          }
      },
      centerCompassClick() {
          let x = window.viewer.canvas.clientWidth / 2;
          let y = window.viewer.canvas.clientHeight / 2;
          let result = window.viewer.camera.pickEllipsoid(new Cartesian2(x, y)); // 获取中心点位置
            if (result) {
                    window.viewer.camera.flyTo({
                    destination: this.getCameraPosition(result), // 设置位置
                    orientation: {
                        heading: CesiumMath.toRadians(0),
                        pitch: CesiumMath.toRadians(-90),
                        roll: CesiumMath.toRadians(0)
                    },
                    duration: 2
                          });
                }
      },
      getCameraPosition(result) {
        let dis = Cartesian3.distance(window.viewer.camera.positionWC, result); // 计算相机位置到中心点位置的距离
        let curPosition = Ellipsoid.WGS84.cartesianToCartographic(result); // 地理坐标
        curPosition.height = curPosition.height + dis; // 地理坐标加对应距离即为高度
        return Ellipsoid.WGS84.cartographicToCartesian(curPosition); // 返回计算后的相机位置
      }

    }
 };
</script>
<style scoped>
.pitchStyleClass{
  opacity: 0.4;
}
.pitchUp{
   width: 60px;
    height: 45px;
    position: absolute;
    margin-left: -30px;
    left: 50%;
    z-index: 1;
    background: url(./img/compass.png) -605px -98px no-repeat;
    top: 7px;
}
.pitchDown{
    width: 60px;
    height: 45px;
    position: absolute;
    margin-left: -30px;
    left: 50%;
    z-index: 1;
    background: url(./img/compass.png) -605px -98px no-repeat;
    top: 132px;
    transform: rotateZ(180deg);
}
.pitchUp:hover{
    background: url(./img/compass.png) -605px -47px no-repeat;
}
.pitchDown:hover{
    background: url(./img/compass.png) -605px -47px no-repeat;
}
.rotateLeft{
    left: 10px;
    width: 42px;
    height: 104px;
    top: 38px;
    position: absolute;
    z-index: 2;
    background: url(./img/compass.png) -603px -154px no-repeat;
}
.rotateLeft:hover{
    background: url(./img/compass.png) -557px -153px no-repeat;

}
.rotateRight{
    right: 10px;
    width: 42px;
    height: 104px;
    top: 38px;
    position: absolute;
    z-index: 2;
    background: url(./img/compass.png) -603px -154px no-repeat;
    right: 10px;
    transform: rotateY(180deg);
}
.rotateRight:hover{
    background: url(./img/compass.png) -557px -153px no-repeat;
}

.centerPointer{
    position: absolute;
    width: 60px;
    height: 96px;
    top: 0;
    left: 18px;
    border: none;
    z-index: 2;
    background: url(./img/compass.png) -562px -52px no-repeat;
    pointer-events:none;
}
.compass {
      position: relative;
      height: 184px;
      width: 184px;
      background: url(./img/compass.png) -44px -60px no-repeat;
}
.centerCompass{
    pointer-events:none;
    top: 92px;
    left: 50%;
    position: absolute;
    margin: -48px;
    width: 96px;
    height: 96px;
    z-index: 1;
    background: url(./img/compass.png) -462px -52px no-repeat;
}
.centerCompassBack{
    top: 92px;
    left: 50%;
    position: absolute;
    margin: -48px;
    width: 96px;
    height: 96px;
    z-index: 0;
}
.container {
    position:absolute;
    width: 184px;
    height: 184px;
    margin: 0;
    padding: 0;
    top:10px;
    left: 10px;
    z-index: 1000;
    transform-origin: 0 0;
    transform: scale(0.5);
}
</style>
